import styled from "styled-components";

export const MainContainer = styled.div`
  width: 95%;
  margin: 0 auto;
`;

export const InnerContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  margin-top: 70px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  @media screen and (max-width: 768px) {
    margin-top: 20px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const StyledHeading = styled.div`
  color: #000;
  font-family: Inter;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  &:before {
    content: "";
    padding: 0px 2px 0px 20px;
    border-radius: 4px;
    margin-right: 20px;
    background-color: #ed6928;
  }
  @media screen and (max-width: 768px) {
    font-size: 20px;
    &:before {
      padding: 0px 2px 0px 10px;
      margin-right: 14px;
    }
  }
`;

export const SearchWrap = styled.div`
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  padding: 7px 12px;
  min-width: 240px;
  flex: 0 1 280px;
  @media (max-width: 640px) {
    min-width: 100%;
    flex-basis: 100%;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  font-family: "Inter", sans-serif;
  color: #111;
`;

export const PaginationWrapper = styled.div`
  text-align: center;
  margin-top: 60px;
`;
